import EducationStatementPage from './EducationStatement.page';

export default EducationStatementPage;
